module.exports = __webpack_public_path__ + "static/media/Python_logo_icon.10327dc6.png";